define([
	'internal_util/Logger',
	'internal_util/Util',
	'internal_util/XMLUtil',
	'model/AuthenticationOption',
	'model/AuthenticationOptionGroup',
	'model/RequestedAttribute',
	'model/Image',
	'factory/AttributesFactory',
	'factory/RequestedAttributesFactory',
	'factory/AuthenticationOptionsFactory',
	'lib/jquery'
], function (
		Logger,
		Util,
		XMLUtil,
		AuthenticationOption,
		AuthenticationOptionGroup,
		RequestedAttribute,
		Image,
		AttributesFactory,
		RequestedAttributesFactory,
		AuthenticationOptionsFactory,
		jQuery
		) {
	'use strict';

	/**
	 * AuthenticationOptionGroupsFactory class
	 */
	return new function () {
		var privacyProfileNamespace = 'urn:oasis:names:tc:SAML:profile:privacy',
				metadataUiNamespace = 'urn:oasis:names:tc:SAML:metadata:ui';


		// public methods

		this.create = function (optionsXML, authenticationOptions) {
			var authenticationOptionGroups = new Array(),
					authenticationOptionGroupXML = null,
					authenticationOptionRefs = null,
					groupedAuthenticationOptions = null,
					id = null,
					uiInfo = null,
					logo = null,
					description = null,
					image = null,
					attributes = null,
					requestedAttributes = null,
					i, j, k,
					option;

			authenticationOptionGroupXML = XMLUtil.find(privacyProfileNamespace, optionsXML, 'AuthenticationOptionGroup');

			if (authenticationOptionGroupXML === null) {
				return authenticationOptionGroups;
			}

			for (i = 0; i < authenticationOptionGroupXML.length; i++) {
				authenticationOptionGroupXML[i] = jQuery(authenticationOptionGroupXML[i]);

				uiInfo = XMLUtil.find(metadataUiNamespace, authenticationOptionGroupXML[i], 'UIInfo', true);
				authenticationOptionRefs = XMLUtil.find(privacyProfileNamespace, authenticationOptionGroupXML[i], 'AuthenticationOptionRef');
				logo = XMLUtil.find(metadataUiNamespace, uiInfo, 'Logo');

				groupedAuthenticationOptions = new Array();

				for (j = 0; j < authenticationOptionRefs.length; j++) {
					authenticationOptionRefs[j] = jQuery(authenticationOptionRefs[j]);

					for (k = 0; k < authenticationOptions.length; k++) {
						if (authenticationOptions[k].id() === authenticationOptionRefs[j].text().trim()) {
							groupedAuthenticationOptions.push(authenticationOptions[k]);

							break;
						}
					}
				}

				id = authenticationOptionGroupXML[i].attr('AuthenticationOptionGroupID').trim();
				description = XMLUtil.find(metadataUiNamespace, uiInfo, 'DisplayName').text().trim();
				image = new Image(logo.text().trim(), logo.attr('width'), logo.attr('height'));
				attributes = AttributesFactory.create(authenticationOptionGroupXML[i]);
				requestedAttributes = RequestedAttributesFactory.createForAuthenticationOption(optionsXML,
						authenticationOptionGroupXML[i]);

				if (attributes.length === 0) {
					attributes = null;
				}

				option = new AuthenticationOptionGroup(
						id,
						groupedAuthenticationOptions,
						description,
						image,
						attributes,
						requestedAttributes);
				RequestedAttributesFactory.resolveOrigins(option);
				authenticationOptionGroups.push(option);
			}

			return authenticationOptionGroups;
		};

		this.createFromObject = function (authenticationOptionGroupObject) {
			var authenticationOptionGroups,
					requestedAttributes = Array(),
					i;

			if (authenticationOptionGroupObject.hasOwnProperty('requestedAttributes')) {
				for (var j = 0; j < authenticationOptionGroupObject['requestedAttributes'].length; j++) {
					requestedAttributes.push(new RequestedAttribute(
							authenticationOptionGroupObject['requestedAttributes'][j]['name'],
							authenticationOptionGroupObject['requestedAttributes'][j]['isRequired'],
							authenticationOptionGroupObject['requestedAttributes'][j]['purpose']));
				}
			}

			if (Util.isArray(authenticationOptionGroupObject)) {
				authenticationOptionGroups = new Array();

				for (i = 0; i < authenticationOptionGroupObject.length; i++) {
					authenticationOptionGroups.push(new AuthenticationOptionGroup(
							authenticationOptionGroupObject[i]['id'],
							AuthenticationOptionsFactory.createFromObject(authenticationOptionGroupObject[i]['authenticationOptions']),
							authenticationOptionGroupObject[i]['description'],
							new Image(authenticationOptionGroupObject[i]['image']['url'],
									authenticationOptionGroupObject[i]['image']['width'],
									authenticationOptionGroupObject[i]['image']['height']),
							(authenticationOptionGroupObject[i]['attributes'] !== null ?
									AttributesFactory.createFromObject(authenticationOptionGroupObject[i]['attributes']) : null),
							requestedAttributes));
				}
			} else {
				authenticationOptionGroups = new AuthenticationOptionGroup(
						authenticationOptionGroupObject['id'],
						AuthenticationOptionsFactory.createFromObject(authenticationOptionGroupObject['authenticationOptions']),
						authenticationOptionGroupObject['description'],
						new Image(authenticationOptionGroupObject['image']['url'],
								authenticationOptionGroupObject['image']['width'],
								authenticationOptionGroupObject['image']['height']),
						(authenticationOptionGroupObject['attributes'] !== null ?
								AttributesFactory.createFromObject(authenticationOptionGroupObject['attributes']) : null),
						requestedAttributes);
			}

			return authenticationOptionGroups;
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/factory/AuthenticationOptionGroupsFactory.js
// module id = 62
// module chunks = 7